import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { ProductTypeModel } from '@x/model/product-type.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

/**
 * Product types loaded once at bootstrap, so that synchronous consumers
 * (e.g. the navigation builder) can resolve a product type name by id.
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalProductTypeService {
  private _types$ = new BehaviorSubject<ProductTypeModel[] | null>(null);
  types$ = this._types$.asObservable().pipe(filter((res): res is ProductTypeModel[] => res !== null));

  constructor(private http: FlamingoHttpService) {}

  get types(): ProductTypeModel[] {
    return this._types$.value ?? [];
  }

  set types(types: ProductTypeModel[]) {
    this._types$.next(types);
  }

  getProductTypes(): Observable<ProductTypeModel[]> {
    return this.http.get<ProductTypeModel[]>(`/product-types`).pipe(tap(res => (this.types = res)));
  }

  name(id: number): string | undefined {
    return this.types.find(type => type.id === id)?.name;
  }
}
